export default function Loader() {
  return (
    <>
      <div className="loader">
        <span className="spinner"></span>
      </div>
    </>
  );
}
